import { Configuration2D } from '../../../configuration2d';
import { WorkbenchLocation } from '../workbench-location';
import { Resume } from '../resume';
import { ConfigurationPlan } from './configuration-plan';
import { ConfigurationGroup } from './configuration-group';
import { isHeightValid } from './configuration-splashback';

export class WorkbenchConfiguration extends Configuration2D {
  location: WorkbenchLocation;

  _resume: Resume;

  isComplete: boolean;
  inIdf: boolean;
  numberOfAssembly: number;

  workbenchConfigurationPlans: ConfigurationPlan[];

  /**
   * Uniquement front
   */
  workbenchConfigurationGroups: ConfigurationGroup[];

  hasSuperposition: boolean;

  get resume() {
    return this._resume;
  }

  override set resume(resume: Resume) {
    this._resume = resume;
  }
}

export function setNumberOfAssembly(workbenchConfigurationGroups: ConfigurationGroup[]): number {
  var number = 0;
  workbenchConfigurationGroups?.forEach(group => {
    number += group.workbenchConfigurationPlans.length - 1;
  });
  return number;
}

/**
 * Vérifie que les crédence ont une hauteur.
 */
export function allSplashbackHaveHeight(configuration: WorkbenchConfiguration): boolean {
  let allHaveHeight = false;

  // Pour tout les plans de la configurations on vérifie
  allHaveHeight = configuration.workbenchConfigurationPlans.every(plan => {
    // Soit le plan ne possède pas de crédence = OK
    return (
      plan.configurationSplashbacks.length === 0 ||
      // OU soit les crédences ont une hauteur OK
      plan.configurationSplashbacks.every(splashback => splashback != null && isHeightValid(splashback))
    );
  });

  return allHaveHeight;
}

/**
 * Vérifie que la configuration n'a pas de crédence.
 */
export function noSplashback(configuration: WorkbenchConfiguration): boolean {
  return configuration.workbenchConfigurationPlans.every(plan => plan.configurationSplashbacks?.length === 0);
}
